<template>
    <div class="respond-application-file">
      {{ placeholder }}
      <slot name="input" />
    </div>
</template>

<script>
export default {
    name: 'RespondApplicationFile',
    props: ['placeholder'],
}
</script>

<style lang="scss" scoped>
.respond-application-file{
  display: flex;
  align-items: center;
  position: relative;
  border: 1px dashed #87929D;
  border-radius: 6px;
  padding: 0 15px;
  height: 50px;
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  color: #68737D;
  :deep{
    input{
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      opacity: 0;
      cursor: pointer;
    }
  }
}
</style>